// @flow
import React, { Component } from 'react';
import type { QuoteSequence } from 'store/modules/quotes';
import { connect } from 'react-redux';
import type { State } from 'store';

import QuoteSequences from 'components/quote/QuoteSequences/QuoteSequences';

type Props = {
  sequences: ?(QuoteSequence[]),
  username: string,
  currentQuoteId: string,
};

class QuoteSequencesContainer extends Component<Props> {
  render() {
    const { sequences, username, currentQuoteId } = this.props;

    return (
      <QuoteSequences sequences={sequences} username={username} currentQuoteId={currentQuoteId} />
    );
  }
}

export default connect(
  ({ quotes }: State) => ({
    sequences: quotes.sequences,
    currentQuoteId: quotes.quote && quotes.quote.id,
  }),
  () => ({}),
)(QuoteSequencesContainer);



// WEBPACK FOOTER //
// ./src/containers/quote/QuoteSequencesContainer.js